<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SMS_ID')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.messageCmid"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_STT')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="messageSendStatusCode"
              :selected="searchFrame.messageSendStatusCode"
              :pageId="this.$options.name"
              codeId="COD_SMS_SEND_STT"
              defaultOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRD')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              ref="dp"
              :value="searchFrame.rangeDate"
              sticky
              @confirm="onRangeConfirm"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.subject"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CNTN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchFrame.messageBody"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_USR_TEL')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              ref="sendPhone"
              v-model.trim="searchFrame.sendPhone"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              maxlength="11"
              :mask="mask"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RECP_USR_TEL')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              ref="destPhone"
              v-model.trim="searchFrame.destPhone"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              maxlength="11"
              :mask="mask"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-7" />
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="mainGrid"
        :dataset="'ds0'"
        :columns="gridColumns0"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
        :multiselect="false"
        @cellclick="gridCellClick"
      />
      <div class="btn_moreView">
        <p
          :class="paging.totalCount === 0 || paging.count === paging.totalCount ? 'disabled' : ''"
          @click="addRows"
        >
          {{ showMore }}
        </p>
      </div>
      <sui-popup
        v-model="isShownPopupDetail"
        :title="$t('MSG_TIT_SMS_SEND_DTL')"
      >
        <p01
          :pageId="this.$options.name"
          :messageCmid="messageCmid"
          @onDetailAndCancelClick="onDetailAndCancelClick"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import p01 from './components/PGE_CMS_00016_P01';
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00016', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        messageSendStatusCode: {
          key: '',
          label: '',
        },
        messageCmid: '',
        subject: '',
        messageBody: '',
        sendPhone: '',
        destPhone: '',
        rangeDate: {
          from: utils.dateformatToClient(utils.addDay(utils.now('YYYY-MM-DD'), -6), 'S'),
          to: utils.now('YYYY-MM-DD'),
        },
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SMS_ID'),
        datafield: 'messageCmid',
        width: '250px',
      }, {
        text: this.$t('MSG_TXT_SEND_STT'),
        datafield: 'messageSendStatusName',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_RQS_DTM'),
        datafield: 'requestDTM',
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_TITLE'),
        datafield: 'subject',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_CNTN'),
        datafield: 'messageBody',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_SEND_USR_TEL'),
        datafield: 'sendPhone',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_RECP_USR_TEL'),
        datafield: 'destPhone',
        width: '150px',
      }],
      isShownPopupDetail: false,
      messageCmid: '',
      paging: {
        count: 0,
        totalCount: 0,
        curPage: 0,
        searchData: {},
      },
      mask: 'number',
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    showMore() {
      return `${this.$t('MSG_TXT_SHOW_MORE')} (${this.paging.count}/${this.paging.totalCount})`;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    gridCellClick(event) {
      const { rowindex, columnindex } = event.args;
      const [selectedindex] = this.ds0.getSelectedIndexes();
      if (rowindex !== selectedindex && (columnindex === 3 || columnindex === 4)) {
        this.ds0.setSelectedIndex(rowindex);
      }
    },
    onGridSingleButtonClicked(value, dataRow) {
      this.onDetailAndCancelClick(dataRow.messageCmid);
    },
    onResetClick() {
      this.$refs.messageSendStatusCode.reset();
      this.searchFrame.rangeDate = {
        from: utils.dateformatToClient(utils.addDay(utils.now('YYYY-MM-DD'), -6), 'S'),
        to: utils.now('YYYY-MM-DD'),
      };
      this.searchFrame.messageCmid = '';
      this.searchFrame.subject = '';
      this.searchFrame.messageBody = '';
      this.searchFrame.sendPhone = '';
      this.searchFrame.destPhone = '';
    },
    onRangeConfirm(value) {
      const { from, to } = value;
      if (utils.getDayOffset(to, from) > 6) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_SEARCH_UNDER_DY'), '7'));
      } else {
        this.searchFrame.rangeDate = value;
      }
    },
    getSearchData() {
      const data = {
        curPage: 1,
      };
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'messageSendStatusCode')) {
          data[key] = value.key;
        } else if (utils.isEqual(key, 'rangeDate')) {
          data.searchRequestFromDTM = utils.isDate(value.from) ? utils.dateformatToServer(value.from) : '';
          data.searchRequestToDTM = utils.isDate(value.to)
            ? utils.dateformatToServer(value.to, 'S').concat('235959')
            : '';
        } else if (utils.isEqual(key, 'sendPhone') || utils.isEqual(key, 'destPhone')) {
          const phone = this.$refs[key].applyMask(value, this.mask);
          data[key] = utils.join(utils.split(phone, ' - '), '-');
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onSearchClick() {
      if (this.onClickValidate()) return;
      this.paging.curPage = 1;
      this.paging.searchData = this.getSearchData();
      this.searchAction(false);
    },
    addRows() {
      if (this.paging.count < this.paging.totalCount) {
        this.paging.curPage += 1;
        this.paging.searchData.curPage = this.paging.curPage;
        this.searchAction(true);
      }
    },
    searchAction(addRow) {
      http.request(this.$options.name, 'DTS_CMS_00049', {
        query: this.paging.searchData,
      }).then(res => {
        utils.forEach(res.data, data => {
          utils.set(data, 'requestDTM', data.requestDTM.substr(0, utils.indexOf(data.requestDTM, '.')));
        });
        if (addRow) {
          this.paging.count += res.data.length;
          const union = utils.mergeArray(this.ds0.data, res.data);
          this.ds0.setRawData(union);
        } else if (res.data.length > 0) {
          this.paging.totalCount = res.data[0].totalCount;
          this.paging.count = res.data.length;
          this.ds0.setRawData(res.data);
        } else {
          this.paging.totalCount = 0;
          this.paging.count = 0;
          this.ds0.setRawData([]);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onDetailAndCancelClick(messageCmid) {
      this.messageCmid = messageCmid;
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'messageCmid', map: 'messageCmid' },
      { type: 'string', name: 'messageType', map: 'messageType' },
      { type: 'string', name: 'destPhone', map: 'destPhone' },
      { type: 'string', name: 'sendPhone', map: 'sendPhone' },
      { type: 'string', name: 'subject', map: 'subject' },
      { type: 'string', name: 'messageBody', map: 'messageBody' },
      { type: 'string', name: 'requestDTM', map: 'requestDTM' },
      { type: 'string', name: 'sendDTM', map: 'sendDTM' },
      { type: 'string', name: 'messageSendStatusCode', map: 'messageSendStatusCode' },
      { type: 'string', name: 'messageSendStatusName', map: 'messageSendStatusName' },
    ],
  }],
};
</script>
<style scoped>
</style>
